import React from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import { getColor } from 'core/utils/Styles';

const sizes = {
	sm: '8px',
	md: '16px',
	lg: '24px',
	xlg: '32px',
	"2xl": '48px',
};

const spin = keyframes`
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
`;

export const spinnerStyles = css`
	border: 2px solid;
	border-color: ${props => props.bgColor || Spinner.defaultProps.bgColor};
	border-top-color: ${props => props.color || Spinner.defaultProps.color};
	border-radius: 50%;
	animation: ${spin} 0.75s linear infinite;
	width: ${props => sizes[props.size || Spinner.defaultProps.size]};
	height: ${props => sizes[props.size || Spinner.defaultProps.size]};
	margin: ${props => props.center ? '0 auto' : '0'};
`;

const Loader = styled.div`
	${spinnerStyles}
`;


class Spinner extends React.PureComponent {
	render() {
		return (
			<Loader { ...this.props } />
		);
	}
}

Spinner.propTypes = {
	color: PropTypes.string,
	bgColor: PropTypes.string,
	center: PropTypes.bool,
	size: PropTypes.oneOf(['sm', 'md', 'lg', 'xlg', '2xl']),
};

Spinner.defaultProps = {
	color: getColor("primaryBrand"),
	bgColor: getColor("concreteGray"),
	center: true,
	size: 'md',
};

export default Spinner;
